<template>
  <div class="tFooter">
    <!-- 底部-->
    <div class="ibar ibar-tab flex flexa">
      <div class="itab-item" :class="{ iactive: bmTab == 1 }" @click="active(1)">
        <img class="ft-icon" v-if="bmTab == 1" src="../assets/img/tabs/1844.png" />
        <img class="ft-icon" v-if="bmTab != 1" src="../assets/img/tabs/h.png" />
        <span class="itab-label">首页</span>
      </div>
      <!-- <div class="itab-item cart-item" :class="{ iactive: bmTab == 2 }" @click="active(2)">
        <img class="ft-icon" v-if="bmTab == 2" src="../assets/img/tabs/1850.png" />
        <img class="ft-icon" v-if="bmTab != 2" src="../assets/img/tabs/c.png" />
        <span class="itab-label">{{ computedCartText }}</span>
        <i class="sales-count" v-if="shopCardNum > 0">{{ shopCardNum }}</i>
      </div> -->
      <div class="itab-item cart-item" :class="{ iactive: bmTab == 2 }" @click="active(2)">
        <img class="ft-icon" v-if="bmTab == 2" src="../assets/img/tabs/cart-v4-empty.png" />
        <img class="ft-icon" v-if="bmTab != 2" src="../assets/img/tabs/cart-v4-full.png" />
        <span class="itab-label">{{ computedCartText }}</span>
        <i class="sales-count" v-if="shopCardNum > 0">{{ shopCardNum }}</i>
      </div>

      <div class="itab-item" :class="{ iactive: bmTab == 3 }" @click="active(3)">
        <img class="ft-icon" v-if="bmTab == 3" src="../assets/img/tabs/5481.png" />
        <img class="ft-icon" v-if="bmTab != 3" src="../assets/img/tabs/2.png" />
        <span class="itab-label">{{ computedTalkText }}</span>
      </div>
      <div class="itab-item" :class="{ iactive: bmTab == 4 }" @click="active(4)">
        <img class="ft-icon" v-if="bmTab == 4" src="../assets/img/tabs/4.png" />
        <img class="ft-icon" v-if="bmTab != 4" src="../assets/img/tabs/i.png" />
        <span class="itab-label">印迹</span>
      </div>
      <div class="itab-item" :class="{ iactive: bmTab == 5 }" @click="active(5)">
        <img class="ft-icon" v-if="bmTab == 5" src="../assets/img/tabs/5.png" />
        <img class="ft-icon" v-if="bmTab != 5" src="../assets/img/tabs/p.png" />
        <span class="itab-label">我的</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { aPost } from '../utils/request';
import api from '../utils/api';
import storeCartApi from '../api/v3/storeCart';
export default {
  name: 'tFooter',
  data() {
    return {
      shopCardNum: 0,
      // 店铺是否存在活动 0没有，1有
      whetherActivity: 0,
      vueAppTypeName: process.env.VUE_APP_TYPE_NAME || '',
    };
  },
  watch: {
    $route(to, from) {
      this.getShopCardNum();
    },
    // $route(to, from) {
    //   //监听路由变化
    //   console.log('to.meta.index',to.meta.index)
    //   console.log('this.$store.state.bmTab',this.$store.state.bmTab)
    //   if (to.meta.index == 2 || to.meta.index == 10 || to.meta.index == 11) {
    //     this.$store.state.identify = 2;
    //   }
    //   if (
    //     to.meta.index == 1 ||
    //     to.meta.index == 3 ||
    //     to.meta.index == 5
    //   ) {
    //     this.$store.state.identify = 0;
    //   }
    //   if (to.meta.index == 4) {
    //     if (this.$store.state.identify == 1) {
    //       this.$store.state.bmTab = 11;
    //     }else{
    //       this.$store.state.bmTab = to.meta.index;
    //     }
    //   } else {
    //     this.$store.state.bmTab = to.meta.index;
    //   }
    //   // console.log(to);
    //   // console.log(this.$store.state.bmTab);
    //   console.log(this.$route.matched);
    // }
  },
  computed: {
    computedCartText() {
      if (this.vueAppTypeName !== '') {
        return '收藏';
      }
              return '购物车';
    },
    computedTalkText() {
      if (this.vueAppTypeName !== '') {
        return '族宝';
      }
      return '谈宝';
    },
    bmTab() {
      return this.$store.state.bmTab;
    },
    id() {
      return this.$store.state.identify;
    },
  },
  // watch: {},
  methods: {
    ...mapActions(['setIsCart']),

    //购物车商品数量
    async getShopCardNum() {
      try {
        const cartCount = await storeCartApi.count();
        this.shopCardNum = cartCount || 0;
        console.log('购物车数量', this.shopCardNum);
      } catch (error) {
        console.error('获取购物车数量失败:', error);
        this.shopCardNum = 0;
      }
    },
    getCurrentStoreId() {
      const currentStoreId = parseInt(localStorage.getItem('currentStoreId'), 10) || 0;
      if (currentStoreId > 0) {
        return currentStoreId;
      }
      return parseInt(localStorage.getItem('storeId'), 10) || 0;
    },

    active(n) {
      let that = this;
      this.$store.state.bmTab = n;
      if (n == 1) {
        const currentStoreId = this.getCurrentStoreId();
        if (currentStoreId > 0) {
          this.$router.replace({ path: '/', query: { storeId: currentStoreId } }).catch(err => {});
        } else {
          this.$router.replace({ path: '/' }).catch(err => {});
        }
        this.setIsCart(0);
      }
      if (n == 2) {
        this.$router.replace({ path: '/cart' }).catch(err => {});
        this.setIsCart(0);
      }
      if (n == 3) {
        // this.$router.replace({ path: '/Lottery?storeId=' + this.$store.state.storeId }).catch((err) => {})
        this.$router.replace({ path: '/scan' }).catch(err => {});
        this.setIsCart(0);
      }
      if (n == 4) {
        if (this.vueAppTypeName === '') {
          this.$router.replace({ path: '/imprint' }).catch(err => {});
        } else {
          this.$router.replace({ path: '/FocusOn' }).catch(err => {});
        }

        this.setIsCart(1);
      }
      if (n == 5) {
        this.$router.replace({ path: '/profile' }).catch(err => {});
        this.setIsCart(0);
      }
    },
  },
  created() {
    this.getShopCardNum();
  },
};
</script>

<style lang="scss">
.tFooter {
  position: fixed !important; /* 确保位置固定 */
  bottom: 0;
  left: 0;
  right: 0;
  // margin-top: 0.3rem;
  background: #ffffff;
  height: 104px;
  box-shadow: 0px 0px 21px rgba(0, 0, 0, 0.04);
  //opacity: 1;
  z-index: 10;
  .ibar {
    display: flex; // 使用 flex 布局
    justify-content: space-between; // 子元素水平分布
    background: #fff;
    width: 100%; // 确保 .ibar 宽度为 100%

    .itab-item {
      //flex: 0 0 250px;
      //flex: 0 0 calc(100% / 5);
      flex-direction: column;
      height: 100%;
      font-size: 20px;
      // font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 21px;
      color: #aeb2b8;
      text-align: center;

      flex: 1; //均分宽度
      padding: 0 10px; // 可选：给每个项添加一些间距以避免靠得太近
      justify-content: center; // 垂直居中对齐内容
      img {
        width: 46px;
        height: 46px;
        margin: 13px auto 12px;
      }
    }
  }

  .iactive {
    font-size: 20px;
    // font-family: Source Han Sans CN;
    font-weight: 500 !important;
    line-height: 20px;
    color: #000000 !important;
  }

  .cart-item {
    position: relative; // 设置为相对定位，以便子元素绝对定位
    .sales-count {
      width: 45px;
      height: 24px;
      background: #ff3a55;
      position: absolute;
      right: 0px;
      top: 0px;
      border-radius: 22px;
      text-align: center;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tfooter.vue